import { ClickableTextPanel } from "@/Common/Components/ClickableText/ClickableTextPanel";

interface IClickableTextPanelContainerProps {
    context: string;
    inputElementId: string;

    showOverlay?: boolean;
    cssClass?: string;
    maxLength?: number;
    useLocalTextEditor?: boolean;
    onClose: () => void;
}

class ClickableTextPanelContainer extends React.Component<IClickableTextPanelContainerProps, any> {
    private $input: JQuery;
    private $window: JQuery;

    constructor(props: IClickableTextPanelContainerProps) {
        super(props);

        this.$input = $("#" + this.props.inputElementId);
        this.$window = $(window);
    }

    public render(): JSX.Element {
        let overlayStyle: React.CSSProperties = { position: "fixed", left: "0", top: "0", width: "100vw", height: "100vh", zIndex: 99 };
        if (this.props.showOverlay)
            overlayStyle.backgroundColor = "rgba(0, 0, 0, 0.45)";

        let topPos = this.calculateTopPosition(this.$input.innerHeight(), this.$input.offset().top);
        let innerDivStyle: React.CSSProperties = { position: "absolute", top: topPos, left: this.calculateLeftPosition(), zIndex: 199 };

        return (
            <div style={overlayStyle} onClick={() => this.props.onClose && this.props.onClose()}>
                <div style={innerDivStyle} onClick={e => e.stopPropagation()}>
                    <ClickableTextPanel
                        cssClass={`text-helper-container ${this.props.cssClass}`}
                        context={this.props.context}
                        inputElementId={this.props.inputElementId}
                        onCloseEvent={this.props.onClose}
                        maxLength={this.props.maxLength}
                        useLocalTextEditor={this.props.useLocalTextEditor}
                    />
                </div>
            </div>
        );
    }

    private calculateLeftPosition(): number {
        let width = this.$input.width();
        let left = this.$input.offset().left;

        const clickableWidth = 990;
        const adjustablePixel = 28;
        return Math.min(width + left + adjustablePixel, clickableWidth + left + (width / 2) + adjustablePixel);
    }

    private calculateTopPosition(inputHeight: number, inputTop: number): number {
        const inputBorderThickness = 2;
        const clickableTextHeight = this.isSmallScreen() ? 432 : 403;

        let topPos = inputTop + inputHeight + inputBorderThickness;
        if (topPos + clickableTextHeight > this.getViewportBottom())
            topPos -= clickableTextHeight + inputHeight + inputBorderThickness;

        return topPos;
    }

    private getViewportBottom(): number {
        return this.$window.scrollTop() + this.$window.height();
    }

    private isSmallScreen(): boolean {
        return this.$window.width() < 1800;
    }
}

export { ClickableTextPanelContainer };
